import { useSyncExternalStore } from 'react'
import { t } from '../copy'

const subscribe = (cb: () => void) => {
  window.addEventListener('online', cb)
  window.addEventListener('offline', cb)
  return () => {
    window.removeEventListener('online', cb)
    window.removeEventListener('offline', cb)
  }
}

export function OfflineBanner() {
  const online = useSyncExternalStore(subscribe, () => navigator.onLine, () => true)
  if (online) return null
  return (
    <div role="status" className="material fixed inset-x-0 top-0 z-[60] border-b border-line pt-[env(safe-area-inset-top)]">
      <p className="mx-auto max-w-md px-5 py-2.5 text-center text-[15px] font-medium text-ink">{t('error.offline')}</p>
    </div>
  )
}
